import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Thomas van der Berg",
    role: "Professioneel Detailer",
    content: "Alienjuice heeft mijn detailing naar een hoger niveau getild. De ceramic spray is ongeëvenaard qua glans en bescherming.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
  },
  {
    name: "Lisa Jansen",
    role: "Auto-enthusiast",
    content: "Eindelijk producten die doen wat ze beloven. Mijn BMW glanst als nooit tevoren. Geweldig!",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face",
  },
  {
    name: "Marco de Vries",
    role: "Garage Eigenaar",
    content: "We zijn overgestapt naar Alienjuice voor al onze klanten. De kwaliteit en resultaten spreken voor zich.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
  },
];

const TestimonialsSection = () => {
  return (
    <section className="section-darker relative">
      {/* Background Glow */}
      <div className="absolute bottom-0 left-0 w-[600px] h-[400px] bg-glow-gradient opacity-10 blur-3xl" />
      <div className="absolute top-0 right-0 w-[600px] h-[400px] bg-glow-gradient opacity-10 blur-3xl" />

      <div className="container mx-auto px-4 relative z-10">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-10">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4">
            Wat Klanten <span className="text-gradient-green">Zeggen</span>
          </h2>
          <p className="text-muted-foreground">
            Duizenden tevreden klanten gingen je voor. Lees hun ervaringen.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.name}
              className="card-premium p-8 relative"
            >
              {/* Quote Icon */}
              <Quote className="absolute top-6 right-6 w-10 h-10 text-primary/20" />

              {/* Rating */}
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-primary fill-primary" />
                ))}
              </div>

              {/* Content */}
              <p className="text-foreground mb-6 leading-relaxed">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover border-2 border-primary/30"
                />
                <div>
                  <p className="font-semibold text-foreground">{testimonial.name}</p>
                  <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
